import useHelpKeywords from '@shared/hooks/help/useHelpKeywords';
import { FormattedMessage } from 'react-intl';
import LoginRegisterTransferLink from '../../LoginRegisterTransferLink';
import PublicPage from '../shared/PublicPage';
import LoginForm from './LoginForm';

const Login: FC = () => {
  useHelpKeywords('m:login');

  return (
    <PublicPage
      title={<FormattedMessage id="login.title" />}
      footer={<LoginRegisterTransferLink variant="minimal" to="register" />}
    >
      <LoginForm />
    </PublicPage>
  );
};

export default Login;
